import Alert from "components/Alert/Alert";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ClientRoutes from "routes/ClientRoutes";
import PrivateRoutes from "routes/PrivateRoutes";
import PublicRoutes from "routes/PublicRoutes";
import "./App.css";


function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/dashboard/*" element={<PrivateRoutes />} />
        <Route path="/cp/*" element={<ClientRoutes />} />
        <Route path="/*" element={<PublicRoutes />} />
      </Routes>
      <Alert />
    </>
  );
}

export default App;

